
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export function useProductDetailsSettings() {
  const { organization } = useAuth();

  return useQuery({
    queryKey: ["productDetailsSettings", organization?.id],
    queryFn: async () => {
      console.log("[useProductDetailsSettings] Fetching settings for org:", organization?.id);
      
      if (organization?.id) {
        // Check organization settings first
        const { data: orgSettings, error: orgError } = await supabase
          .from("organization_settings")
          .select("show_product_details")
          .eq("organization_id", organization.id)
          .maybeSingle();

        console.log("[useProductDetailsSettings] Org settings:", orgSettings, "Error:", orgError);

        if (orgSettings && orgSettings.show_product_details !== null) {
          const showProductDetails = orgSettings.show_product_details === 'true' || orgSettings.show_product_details === true;
          console.log("[useProductDetailsSettings] Using org setting:", showProductDetails);
          return { showProductDetails };
        }
      }

      // Fallback to user settings
      const { data: user } = await supabase.auth.getUser();
      if (user?.user?.id) {
        const { data: userSettings, error: userError } = await supabase
          .from("user_settings")
          .select("show_product_details")
          .eq("user_id", user.user.id)
          .maybeSingle();

        console.log("[useProductDetailsSettings] User settings:", userSettings, "Error:", userError);

        if (userSettings && userSettings.show_product_details !== null) {
          const showProductDetails = userSettings.show_product_details === true;
          console.log("[useProductDetailsSettings] Using user setting:", showProductDetails);
          return { showProductDetails };
        }
      }

      // Default to false if no settings found
      console.log("[useProductDetailsSettings] No settings found, defaulting to false");
      return { showProductDetails: false };
    },
    enabled: true
  });
}
